import React from "react";
import * as CHQ from "chq";

import { Time } from "components/common/Time";

const getDateString = (timestamp: string) => new Date(timestamp).toDateString();

type EventTimeProps = {
  event: CHQ.Event;
};

const EventTime: React.FC<EventTimeProps> = ({ event }) => {
  const startsAt = <Time time={event.startsAt} />;

  if (getDateString(event.startsAt) !== getDateString(event.endsAt)) {
    return (
      <>
        <p>{startsAt}</p>
        <p><Time time={event.endsAt} /></p>
      </>
    );
  }

  return <>{startsAt} <Time time={event.endsAt} format=" - %l:%M %p" /></>;
};

export default EventTime;
